import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
// Editorial body + serif + mono are loaded via Bunny Fonts in index.html
// (DS PR 3: Geist + Geist Mono + Libre Caslon Text).
import './styles/globals.css'
import App from './App.tsx'

// Frontend Sentry (CUR-928). Gated on VITE_SENTRY_DSN so local dev without a
// DSN is a no-op. Backend Sentry is initialised separately in web/main.py and
// shared/celery/app.py with its own DSN.
const sentryDsn = import.meta.env.VITE_SENTRY_DSN
if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
  })
}

// CUR-929: React 19 createRoot error hooks. These capture the categories the
// class ErrorBoundary cannot see — root-level errors outside any boundary
// (onUncaughtError) and errors React auto-recovers from (onRecoverableError).
// reactErrorHandler is a no-op when Sentry.init wasn't called (no DSN).
//
// onCaughtError is deliberately NOT wired: boundary-caught errors are
// reported by ErrorBoundary.componentDidCatch (the canonical capture site,
// which also owns the stale-chunk auto-reload suppression). Wiring it would
// double-report every boundary catch and re-report suppressed chunk errors.
createRoot(document.getElementById('root')!, {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    if (import.meta.env.DEV) console.warn('Uncaught error', error, errorInfo.componentStack)
  }),
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
